import { types as t } from 'mobx-state-tree';

import uiStore from './UIStore';

export const DepartmentTranslation = t.model('DepartmentTranslation', {
  title: t.string,
  language: t.string,
});

export default t
  .model('Department', {
    id: t.identifierNumber,
    translations: t.array(DepartmentTranslation),
  })
  .views((self) => ({
    get translatedName() {
      const translation = self.translations.find((t) => t.language === uiStore.language);
      return translation ? translation.title : 'Untranslated department';
    },
  }));
